// noinspection JSUnusedGlobalSymbols

import { eventBus } from '../services/eventBus';
import userService from '../services/user';
import { isFutureVisit } from '../utils';
import { decryptCached } from '../utils/crypto';
import { createReducerFor } from './utils';

const type = 'PATS_VISITS';

export const setPastVisitsData =
    (data = []) =>
        async (dispatch) => {
            dispatch({
                type,
                payload: { pastVisits: data },
            });
        };

const getHashOfPastVisits = (pastVisits) => {
    return pastVisits ? pastVisits.map((e) => e.id + e.data)
        .join('') : '';
};
let pastVisitsFromFirebase;

export const setPastVisits = (pastVisits) => async (dispatch, getState) => {
    let loading = false;
    try {
        loading = getState()?.pastVisits?.isLoading;
    } catch (e) {
        //
    }
    if (!pastVisits || !pastVisits?.length) {
        dispatch({
            type,
            payload: {
                error: null,
                isLoading: false,
                data: null,
            },
        });
    }
    const visitsFromState = getHashOfPastVisits(pastVisitsFromFirebase);
    const visits = getHashOfPastVisits(pastVisits);
    if (visitsFromState !== visits) {
        pastVisitsFromFirebase = pastVisits;
        dispatch({
            type,
            payload: {
                error: null,
                isLoading: true,
            },
        });
        try {
            const userInfo = await userService.getUserInfo();
            const {
                hashKey,
                me,
            } = userInfo;
            const { profileId } = me ?? {};
            const decrypted = pastVisits.map((e) => decryptCached(e.data, hashKey));
            const otherVisits = decrypted.filter(
                ({
                    targetDate,
                    status,
                }) => !(isFutureVisit(targetDate) && status === 'reserved'),
            );
            eventBus.emit('visitsReady', {
                data: otherVisits,
                hashKey,
                profileId,
            });
            dispatch({
                type,
                payload: {
                    error: null,
                    isLoading: false,
                    data: otherVisits,
                },
            });
        } catch (e) {
            dispatch({
                type,
                payload: {
                    error: e,
                    isLoading: false,
                },
            });
        }
    } else if (loading) {
        dispatch({
            type,
            payload: { isLoading: false },
        });
    }
};

export const setPurePastVisits = (pastVisits) => async (dispatch, getState) => {
    let loading = false;
    try {
        loading = getState()?.pastVisits?.isLoading;
    } catch (e) {
        //
    }
    if (!pastVisits || !pastVisits?.length) {
        dispatch({
            type,
            payload: {
                error: null,
                isLoading: false,
                data: null,
            },
        });
        return;
    }

    const otherVisits = pastVisits.filter(
        ({
            targetDate,
            status,
        } = {}) => !(isFutureVisit(targetDate) && status === 'reserved'),
    );
    const userInfo = await userService.getUserInfo();
    const {
        hashKey,
        me,
    } = userInfo;
    const { profileId } = me ?? {};
    eventBus.emit('visitsReady', {
        data: otherVisits,
        profileId,
        hashKey,
    });
    dispatch({
        type,
        payload: {
            error: null,
            isLoading: false,
            data: otherVisits,
        },
    });
};

export const startLoadingPastVisits = () => (dispatch) =>
    dispatch({
        type,
        payload: { isLoading: true },
    });
export const stopLoadingPastVisits = () => (dispatch) =>
    dispatch({
        type,
        payload: { isLoading: false },
    });

export default createReducerFor(type);
